<template>
    <div>
        <order-status-info v-if="order" :brief="brief" :order="order" />
        <template v-if="order && order.address">
            <g-typography
                tag="h4"
                color="body"
                :margins="true"
                font-weight="semibold"
                value="Shipping Address"
                class="g-mt-4 g-mb-4"
            />
            <g-typography
                tag="p"
                size="small"
                :margins="true"
                class="g-mb-4"
            >
                {{ order.address.first_name }} {{ order.address.last_name }}<br>
                {{ order.address.street }}<br>
                <template v-if="order.address.street_2">
                    {{ order.address.street_2 }}<br>
                </template>
                {{ order.address.city }} {{ order.address.state_code }}, {{ order.address.zip }}
            </g-typography>
        </template>
    </div>
</template>

<script>
    import { ACTIVATION_ORDER_SHIPMENT_STATUS_LABELS } from '../../../../../constants/activation-brief-shipment-status';
    import moment from 'moment-timezone';
    import OrderStatusInfo from './OrderStatusInfo';

    export default {
        name:   'ProductShippingInfo',
        components: {OrderStatusInfo},
        props: {
            brief: {
              type:     Object,
              required: true,
            },
            order: {
                type: Object,
                default: null,
            },
        },
        computed: {
            /**
             * Label for product stats
             */
            label() {
                return this.order ? `Added ${this.orderCreatedAt} • ${this.shipmentStatus}` : null;
            },

            /**
             * Date when order was created.
             */
            orderCreatedAt() {
                return this.order ? moment(this.order.created_at).format('ll') : null;
            },

            /**
             * The shipment status.
             */
            shipmentStatus() {
                return this.order ? ACTIVATION_ORDER_SHIPMENT_STATUS_LABELS[this.order.shipment_status] : null;
            },
        },
    };
</script>
